import { render, staticRenderFns } from "./venue.vue?vue&type=template&id=6cdd9cb1&scoped=true&"
import script from "./venue.vue?vue&type=script&lang=js&"
export * from "./venue.vue?vue&type=script&lang=js&"
import style0 from "./venue.vue?vue&type=style&index=0&id=6cdd9cb1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd9cb1",
  null
  
)

component.options.__file = "venue.vue"
export default component.exports